import React from 'react'
import { Link } from 'react-router-dom'

const Product = () => {
  return (<>
    <h1 class="text-green-500 text text-center font-bold text-2xl  hover:text-blue-500 "> Coming Soon!</h1>
    <section class="text-gray-600 body-font " >

  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-wrap -m-4">
      <div class="lg:w-1/4 md:w-1/2 p-4 w-full">
        <Link to='/inproduct' class="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" class="object-cover object-center w-full h-full block" src="https://utsports.pk/cdn/shop/products/WhatsAppImage2022-03-10at4.55.18PM_2_1024x.jpg?v=1646920484"/>
        </Link>
        <Link to ='/inproduct'><div class="mt-4 ">
          <h3 class="text-gray-500 text-xs tracking-widest title-font mb-1">Sport</h3>
          <h2 class="text-gray-900 title-font text-lg font-medium  hover:text-green-500">Cricket Bat</h2>
          <p class="mt-1">PKR:2000</p>
        </div></Link>
      </div>
      <div class="lg:w-1/4 md:w-1/2 p-4 w-full">
        <a class="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" class="object-cover object-center w-full h-full block" src="https://static-01.daraz.pk/p/462f706e857a11289f38c72aad7eb88f.jpg"/>
        </a>
        <div class="mt-4">
          <h3 class="text-gray-500 text-xs tracking-widest title-font mb-1">Sport</h3>
          <h2 class="text-gray-900 title-font text-lg font-medium  hover:text-green-500">Cricket Ball</h2>
          <p class="mt-1">PKR:450</p>
        </div>
      </div>
      <div class="lg:w-1/4 md:w-1/2 p-4 w-full">
        <a class="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" class="object-cover object-center w-full h-full block" src="https://www.alisports.pk/cdn/shop/products/wooden-cricket-stumps-1544172896-4542794.jpg?v=1671747386"/>
        </a>
        <div class="mt-4">
          <h3 class="text-gray-500 text-xs tracking-widest title-font mb-1">Sport</h3>
          <h2 class="text-gray-900 title-font text-lg font-medium  hover:text-green-500">Cricket Wicket</h2>
          <p class="mt-1">PKR:1300</p>
        </div>
      </div>
      <div class="lg:w-1/4 md:w-1/2 p-4 w-full">
        <a class="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" class="object-cover object-center w-full h-full block" src="https://www.alisports.pk/cdn/shop/products/PhotoRoom-20230309_013705.png?v=1678308039"/>
        </a>
        <div class="mt-4">
          <h3 class="text-gray-500 text-xs tracking-widest title-font mb-1">Cloth</h3>
          <h2 class="text-gray-900 title-font text-lg font-medium  hover:text-green-500">Pakistan Cricket Team T-Shirt</h2>
          <p class="mt-1">PKR:1180</p>
        </div>
      </div>
      <div class="lg:w-1/4 md:w-1/2 p-4 w-full">
        <a class="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" class="object-cover object-center w-full h-full block" src="https://theshoppies.pk/wp-content/uploads/2023/08/India-Cricket-Team-ODI-World-Cup-Jersey-2023-f-1.jpg"/>
        </a>
        <div class="mt-4">
          <h3 class="text-gray-500 text-xs tracking-widest title-font mb-1">Cloth</h3>
          <h2 class="text-gray-900 title-font text-lg font-medium  hover:text-blue-500">India Cricket Team T-Shirt</h2>
          <p class="mt-1">PKR:1180</p>
        </div>
      </div>
      <div class="lg:w-1/4 md:w-1/2 p-4 w-full">
        <a class="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" class="object-cover object-center w-full h-full block" src="https://www.alisports.pk/cdn/shop/files/FullSizeRender_58159204-7e10-4b20-9485-bfe48a5d3cdc.jpg?v=1695496889&width=1445"/>
        </a>
        <div class="mt-4">
          <h3 class="text-gray-500 text-xs tracking-widest title-font mb-1">Sport</h3>
          <h2 class="text-gray-900 title-font text-lg font-medium  hover:text-green-500">Cricket Helment</h2>
          <p class="mt-1">PKR:990</p>
        </div>
      </div>
      <div class="lg:w-1/4 md:w-1/2 p-4 w-full">
        <a class="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" class="object-cover object-center w-full h-full block" src="https://www.thesportstore.pk/image/cache/BatingPadAprl16/CTBPCA04-1000x1000.jpg"/>
        </a>
        <div class="mt-4">
          <h3 class="text-gray-500 text-xs tracking-widest title-font mb-1">Sport</h3>
          <h2 class="text-gray-900 title-font text-lg font-medium  hover:text-green-500">Cricket Batting Pads</h2>
          <p class="mt-1">PKR:1890</p>
        </div>
      </div>
      <div class="lg:w-1/4 md:w-1/2 p-4 w-full">
        <a class="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" class="object-cover object-center w-full h-full block" src="https://cdn.sportsshoes.com/product/K/KKA104/KKA104_1000_5.jpg"/>
        </a>
        <div class="mt-4">
          <h3 class="text-gray-500 text-xs tracking-widest title-font mb-1">Sport</h3>
          <h2 class="text-gray-900 title-font text-lg font-medium  hover:text-green-500" >Cricket Shoe</h2>
          <p class="mt-1">PKR:1500</p>
        </div>
      </div>
    </div>
  </div>
</section></>
  )
}

export default Product
